import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Motion";
import { PriceCard } from "@/components/site/PriceCard";

export const Pricing = () => {
  return (
    <section id="prezzi" className="bg-[#F5F5F7] py-24 sm:py-32" data-testid="pricing-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <span className="eyebrow">Prezzi</span>
          <h2 className="font-display mt-4 text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            Prezzi onesti.<br /><span className="text-[#0066FF]">Scegli quanto ti serve.</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#52525b] md:text-lg">
            Starter a 9€ al mese con 10 video. Pro a 19€ con video illimitati e il nome della tua attività nei video.
          </p>
          <Link to="/tool/mimis-video" className="btn-ghost mt-8 h-12 px-6 text-sm" data-testid="pricing-tool-link">
            Guarda come funziona <ArrowRight className="arrow h-4 w-4" />
          </Link>
        </Reveal>
        <Reveal delay={0.1} className="mx-auto w-full max-w-md">
          <PriceCard />
        </Reveal>
      </div>
    </section>
  );
};

export const Story = () => (
  <section className="py-24 sm:py-32" data-testid="story-section">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <span className="eyebrow">Chi siamo</span>
        <p className="font-display mt-6 text-3xl font-semibold leading-[1.25] tracking-tight sm:text-4xl lg:text-5xl">
          MIMIS nasce da un padre e un figlio, <span className="text-[#0066FF]">Franco e Daniel</span>, con un'idea semplice: costruire tool che risolvono{" "}
          <span className="underline decoration-[#0066FF] decoration-4 underline-offset-[10px]">problemi veri</span>. Si parte dall'Italia. Poi il mondo.
        </p>
      </Reveal>
    </div>
  </section>
);

export const FinalCta = () => {
  return (
    <section className="px-3 pb-3 sm:px-5 sm:pb-5" data-testid="final-cta-section">
      <div className="grain relative overflow-hidden rounded-[2rem] bg-[#111111] px-6 py-24 text-center text-white sm:rounded-[2.5rem] sm:py-32">
        <div className="pointer-events-none absolute left-1/2 top-full h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.55),transparent_65%)]" />
        <Reveal className="relative">
          <h2 className="font-display mx-auto max-w-3xl text-4xl font-bold leading-[1.05] tracking-tight sm:text-6xl">
            Il primo tool è disponibile ora.<br /><span className="text-[#4d94ff]">Crea il tuo primo video.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-lg text-base text-zinc-300 md:text-lg">MIMIS Video Italia è online: il primo video è gratis, pronto in 60 secondi.</p>
          <Link to="/tool/mimis-video" className="btn-blu mt-10 h-14 px-8 text-base" data-testid="final-cta-try-button">
            Prova MIMIS Video gratis <ArrowRight className="arrow h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
